export default "__VITE_ASSET__BNazosrv__ 768w, __VITE_ASSET__CNu6L1Oo__ 1280w, __VITE_ASSET__DJkH_2aK__ 2048w";